/* eslint-disable react/jsx-props-no-spreading */
/**
 * @description Renders a date input component for keeping track of the day someone was assigned to the contract
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { DateTime } from 'luxon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import withErrorBoundary from '@seccon/shared/ui/hocs/with-error-boundary';

/**
 * Validates the date value and, if its invalid, replaces it with a today's date (which is valid)
 * @param {string} value - value to validate
 * @param {() => DateTime} onChange - onChange handling for changing the date to a valid date
 */
function validateDate (value, onChange) {
  if (value === '' || value === 'MM/DD/YYYY') {
    onChange(null)
  } else if (!/\d{2}\/\d{2}\/\d{4}/gi.test(value)) {
    onChange(DateTime.now())
  }
}

const DateAssigned = ({ id, required }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={id}
      render={({ field: { onChange, value } }) => (
        <DatePicker
          label='Date Assigned'
          onChange={(newValue) => onChange(newValue)}
          slotProps={{
            textField: {
              onBlur: (evt) => validateDate(evt.target.value, onChange),
              size: 'small',
              required
            }
          }}
          value={value ?? null}
        />
      )}
    />
  );
};

DateAssigned.propTypes = {
  id: PropTypes.string.isRequired,
  required: PropTypes.bool
};

DateAssigned.defaultProps = {
  required: false
}

export default withErrorBoundary(DateAssigned);
